import { FormattedTodo, Todo, TodoActionType } from '../types';

export const getActionTypeOfTodoItem = (status: string): TodoActionType => {
  switch (status) {
    case 'offerMade12HoursAgo':
    case 'offerMade24HoursAgo':
    case 'offerMade36HoursAgo':
    case 'offerMade48HoursAgo':
      return TodoActionType.OFFER;

    case 'offerAccepted12HoursAgo':
    case 'offerAccepted24HoursAgo':
    case 'offerAccepted36HoursAgo':
    case 'offerAccepted48HoursAgo':
      return TodoActionType.OFFER_ACCEPTED;
    case 'offerRejected12HoursAgo':
    case 'offerRejected24HoursAgo':
    case 'offerRejected36HoursAgo':
    case 'offerRejected48HoursAgo':
      return TodoActionType.OFFER_REJECTED;
    case 'offerExpired12HoursAgo':
    case 'offerExpired24HoursAgo':
    case 'offerExpired36HoursAgo':
    case 'offerExpired48HoursAgo':
      return TodoActionType.OFFER_EXPIRED;
    case 'bgCheckRequested24HoursAgo':
    case 'bgCheckRequested48HoursAgo':
    case 'bgCheckRequested72HoursAgo':
    case 'bgCheckFlaggedByCertnCandidates':
    case 'bgCheckCleared':
    case 'bgCheckNotProcessedByCertn24HoursAgoCandidates':
      return TodoActionType.BACKGROUND_CHECK;
    case 'hireFormRequested12HoursAgo':
    case 'hireFormRequested24HoursAgo':
    case 'hireFormRequested48HoursAgo':
    case 'hireFormRequested72HoursAgo':
    case 'hireFormCompleted24HoursAgo':
    case 'hireFormHelpRequested':
    case 'hireFormInReview':
      return TodoActionType.HIRE_FORM;
    case 'languageEvaluation':
      return TodoActionType.LANGUAGE_EVALUATION;
    case 'responseToCandidate':
    case 'dialogflow':
      return TodoActionType.CONVERSATIONAL_AI;
    case 'workbrightRequested24HoursAgo':
    case 'workbrightRequested36HoursAgo':
    case 'workbrightRequested48HoursAgo':
    case 'workbrightRequested60HoursAgo':
    case 'workbrightRequested72HoursAgo':
    case 'workbrightRestarted24HoursAgo':
    case 'workbrightRestarted36HoursAgo':
    case 'workbrightRestarted48HoursAgo':
    case 'workbrightRestarted60HoursAgo':
    case 'workbrightRestarted72HoursAgo':
    case 'workbrightCompleted':
    case 'workbrightAccepted':
    case 'workbrightDeclined':
      return TodoActionType.I9_VERIFICATION;
    case 'reviewPausedQuestionAnswer':
      return TodoActionType.REVIEW_ANSWERS;
    case 'upcomingInterviews':
      return TodoActionType.UPCOMING_INTERVIEWS;
    default:
      return TodoActionType.OTHER;
  }
};

export const formatData = (todoList: Todo[]): FormattedTodo[] => {
  return todoList?.map((item) => ({
    id: item.recruiterActionId,
    actionType: getActionTypeOfTodoItem(item.status),
    appointment: item.appointment,
    location: item.businessName,
    candidateFullName: `${item.firstName} ${item.lastName}`,
    candidateId: item.id,
    position: item.position,
    status: 'To Do',
    category: item.category,
    lastStatus: item.lastUpdate,
    title: item.status,
    description: item.status,
    customName: item.customName,
    latestHelpRequestedFor: item?.latestHelpRequestedFor,
    hireDetailsRequestedAt: item.hireDetailsRequestedAt,
    helpRequestedMessages: item.helpRequestedMessages,
    seekerHireDetailId: item?.seekerHireDetailId,
    todoStatus: item.todoStatus ?? '',
    statusAssignedRecruiter: item?.statusAssignedBy?.recruiterId ?? '',
    inReviewQuestionList: item.inReviewQuestionList,
    monetized: item?.monetized,
    offerAcceptanceStatus: item.offerAcceptanceStatus,
    latestHelpRequestedLabel: item.latestHelpRequestedLabel,
    hireFormTemplate: item.hireFormTemplate,
    hireFormTemplateId: item.hireFormTemplateId,
    isSeekerPreviouslyMonetized: item.isSeekerPreviouslyMonetized,
  }));
};
